// extracted by mini-css-extract-plugin
export default {"rating":"lO-z","numberOfStars":"mO-z","count":"nO-z","barGraphSpacing":"oO-z","barGraph":"pO-z"};